import React, { Component, useState } from "react";
import { connect } from 'react-redux'
import './Startup.css';
import KeyboardMenu from '../keyboard-menu/KeyboardMenu';
import Menu from '../utils/menu/Menu';
import { logOutAsync, startNewGame } from '../../redux/actions/user.actions';
import { getCharacterAsync, newCharacterAsync, changeCharacter } from '../../redux/actions/character.actions';
import { initialisingPanelStarted, hideAllMenus } from '../../redux/actions/keyboard-shortcuts.actions';
import { getUserBedsAsync } from '../../redux/actions/furniture.actions';
import { getCharacterPanelsAsync } from '../../redux/actions/character-panel.actions';
import {
    selectIsInitialisingApp,
    selectIsInitialisingPanel,
    selectPossibleCharacters,
    selectUser,
    selectCharacterPanels,
    selectRooms
} from '../../redux/selectors';
import TextInput from '../utils/text-input/TextInput';

import { getMinutes } from 'date-fns';

class Startup extends React.Component {
    state = {
        isBedSelectShowing: false,
        availableBeds: [],
        navigationHandler: this.navigationHandler.bind(this),
        isCreditsShowing: false,
        credits: [
        	{
        		text: 'Game Design & Programming.....',
        		hint: 'Harry Bishop'
        	},
        	{
        		text: 'Art & Writing.................',
        		hint: 'Ami Bogin'
        	},
        	{
        		text: 'Music & Sound Design..........',
        		hint: 'Ana Roman'
        	},
        	{
        		text: 'Music.........................',
        		hint: 'Infinite Vibes'
        	},
        	{
        		text: 'Funding.......................',
        		hint: 'Medienboard Brandenburg/Berlin'
        	},
        	{
        		text: '',
        	},
        	{
        		text: '',
        	},
        	{
        		text: '',
        	},
        	{
        		text: '',
        	},
        	{
        		text: 'Field Recordings',
        	},
        	{
        		text: 'Howler Monkeys-Belize.wav by RTB45 -- https://freesound.org/s/148422/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Redwood Forest After Rain by RTB45 -- https://freesound.org/s/641475/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Cloud Forest Frogs by RTB45 -- https://freesound.org/s/473572/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Amazon Jungle - Night by RTB45 -- https://freesound.org/s/473570/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Amazon Jungle - Day by RTB45 -- https://freesound.org/s/473569/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Mount Moganshan Insect Chorus by RTB45 -- https://freesound.org/s/325321/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Dawn Chorus From Himalayan Foothills by Calcuttan -- https://freesound.org/s/429048/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Frogs in North Carolina Marshes by courter -- https://freesound.org/s/447819/ -- License: Creative Commons 0',
        	},
        	{
        		text: 'Frogs 2 min by Audio_Hoarder_Garage -- https://freesound.org/s/788360/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Frogs - Spring Peepers; Southern Chorus Frogs and Insects in Background by TheKingOfGeeks360 -- https://freesound.org/s/792679/ -- License: Creative Commons 0',
        	},
        	{
        		text: 'Mineiros Brasil selva - 3.12.17 - midnight frog chorus long.wav by samwd -- https://freesound.org/s/414401/ -- License: Creative Commons 0',
        	},
        	{
        		text: 'Savannah Frogs 2.WAV by Danjocross -- https://freesound.org/s/238878/ -- License: Creative Commons 0',
        	},
        	{
        		text: 'ANMLAmph_Frogs Croaking 01_KVV AUDIO_FREE by KVV_Audio -- https://freesound.org/s/807930/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Marsh Frogs Calling by naturenotesuk -- https://freesound.org/s/735123/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Sestrže - Pond and surroundings.wav by dibko -- https://freesound.org/s/641010/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'birds dawn chorus Tsitsikamma South Africa by arablelands87 -- https://freesound.org/s/798221/ -- License: Attribution 4.0',
        	},
        	{
        		text: 'Birds Bontebok NP South Africa by arablelands87 -- https://freesound.org/s/798216/ -- License: Attribution 4.0',
        	},
    	],
    	isResetTopChildMenu: false
    }

	constructor() {
		super();
	}

	start(command, print) {
		this.props.startNewGame();
	}

	selectCharacter(character) {
		if (character.text === '<Credits>') {
			this.setState({
				isCreditsShowing: true,
				isResetTopChildMenu: true
			})

			setTimeout(() => {
				this.setState({
					isResetTopChildMenu: false
				})
			})
			return;
		}
		if (character.text === 'New Character' && !this.state.isLoading) {
			if (this.props.characters.length === 0) {
				// IF you have no characters, just make the call
				this.setState({
					isLoading: true
				})
				this.props.newCharacterAsync({ userId: this.props.user.user._id })
					.then(() => {
						this.setState({
							isLoading: false
						})
					})
			} else {
				// IF you have characters, get list of unassigned beds.
				this.props.getUserBedsAsync({ userId: this.props.user.user._id })
					.then((userBeds) => {
						if (userBeds.length <= this.props.characters.length) {
							this.setState({
								isBedSelectShowing: true,
								availableBeds: [],
							})
							return;
						}

						let unassignedBeds = userBeds.filter(bed => (!bed.ownerCharacterId))

						unassignedBeds = unassignedBeds.map(bed => {
							const panel = this.props.characterPanels.find(characterPanel => (characterPanel.panelId === bed.panelId))
							let text = 'Unknown location'

							if (panel) {
								text = panel.locationName
							}

							text += ` [${bed.position.x} ${bed.position.y}]`

							return {
								...bed,
								text
							}
						})

						this.setState({
							isBedSelectShowing: true,
							availableBeds: unassignedBeds
						})
					});
			}
			return;
		}

		if (character.text === 'Give Embark Code') {
			console.log('okay we display a text input here')
			this.setState({
				isTeleporterCodeInputShowing: true
			})
			setTimeout(() => (document.getElementsByClassName('textarea')[0].focus()))
			return;
		}

		if (character.text === 'Log Out') {
			this.logout()
			return;
		}

		if (character.text.indexOf('New Character') > -1) {
			// we do nothing!
			return;
		}

		if (character._id === localStorage.getItem('characterId')) {
			this.props.hideAllMenus();
			return;
		}

		localStorage.setItem('characterId', character._id);


		setTimeout(() => {
			this.props.changeCharacter();
			this.props.initialisingPanelStarted();
		}, 10)
		this.props.getCharacterAsync({ userId: character.userId });
	}

	selectBed(bed) {
		this.setState({
			isBedSelectShowing: false,
			isLoading: true
		});

		console.log('here we go pal: ', bed)
		this.props.newCharacterAsync({ userId: this.props.user.user._id, bedId: bed._id })
			.then(() => {
				this.setState({
					isLoading: false
				})
			})
	}

    navigationHandler(event) {
        if (event.code === 'Escape' && this.state.isBedSelectShowing) {
            this.setState({
                isBedSelectShowing: false,
            });

            event.preventDefault();
            return;
        }
        if (event.code === 'Escape' && this.state.isTeleporterCodeInputShowing) {
            this.setState({
                isTeleporterCodeInputShowing: false
            });

            event.preventDefault();
            return;
        }
        if (event.code === 'Escape' && this.state.isCreditsShowing) {
            this.setState({
                isCreditsShowing: false
            });

            event.preventDefault();
            return;
        }
    }

	componentWillUnmount() {
        document.removeEventListener('keydown', this.state.navigationHandler)
    }

    componentDidMount() {
        document.addEventListener('keydown', this.state.navigationHandler);
        this.props.getCharacterPanelsAsync({ userId: this.props.user.user._id })
        setTimeout(() => {
        	this.props.getCharacterAsync({ userId: this.props.user.user._id });
        }, 1000)
    }

	continue(command, print) {
		console.log('continue');
	}

	settings(command, print) {
		console.log('settings');
	}

	logout(command, print) {
        localStorage['feathers-jwt'] = null;
        this.props.logOutAsync();
        window.location.reload();
	}

	isNewCharacterPossible() {
		return true;
		// if (this.props.characters.length > 0) {
		// 	return true;
		// }

		// const minutes = getMinutes(new Date());

		// return !(
		//     (minutes >= 0 && minutes <= 5) ||
		//     (minutes >= 25 && minutes <= 35) ||
		//     (minutes >= 55 && minutes <= 59)
		// );
	}

	teleporterCodeWritten(teleporterId) {
		this.setState({
			isTeleporterCodeInputShowing: false,
			isLoading: true
		})

		this.props.newCharacterAsync({ userId: this.props.user.user._id, teleporterId })
			.then(() => {
				this.setState({ isLoading: false })
			})
	}

	render() {
		const otherOptions = this.props.characters.length === 0 ? [
			{
				text: this.isNewCharacterPossible() ? "New Character" : "New Character [wait until :06 or :36]",
				callback: this.start.bind(this),
				className: !this.isNewCharacterPossible() ? 'disabled' : ''
			},
			{
				text: "Give Embark Code",
				callback: this.start.bind(this),
			},
			{
				text: "Log Out",
				callback: this.start.bind(this)
			},
			{
				text: "<Credits>",
			},
		] : [
			{
				text: this.isNewCharacterPossible() ? "New Character" : "New Character [wait until :06 or :36]",
				callback: this.start.bind(this),
				className: !this.isNewCharacterPossible() ? 'disabled' : ''
			},
			{
				text: "Log Out",
				callback: this.start.bind(this)
			},
			{
				text: "<Credits>",
			},
		]
			      					
	    return (
	      	<div className="startup">
	      		<p className="header">[ <span className="title">Settle Gliese</span> ]</p>
	      		<div id="error" className={this.state.isTeleporterCodeInputShowing ? 'new-message-container' : 'hidden'}>
	      			<TextInput onTextSubmit={this.teleporterCodeWritten.bind(this)} />
	      		</div>
	      		<div className="options-container">
	      			{
	      				this.state.isBedSelectShowing ? (

		      				this.state.availableBeds.length > 0 ? (
				      			<Menu menuContainer="options-container"
				      				optionChosen={(bed) => (this.selectBed(bed))}
				      				options={[
				      					...this.state.availableBeds.map(bed => ({
				      						...bed,
				      					})),
				      				]
				      			}/>
	      					): (
	      						<p className="center">To spawn a new character, you need more beds than alive characters, and have at least one bed unassigned.</p>
	      					)
      					) : this.state.isCreditsShowing ? (
      						<Menu menuContainer="options-container"
			      				options={this.state.credits}
			      				isResetTopChildMenu={this.state.isResetTopChildMenu}
			      			/>
      					) : (
			      			<Menu menuContainer="options-container"
			      				optionChosen={(character) => (this.selectCharacter(character))}
			      				options={[
			      					...this.props.characters.map(character => {
			      						const isLobbyReady = this.props?.rooms?.find(room => {
			      							return room.metadata?.characterIds?.find(characterId => characterId === character._id)
			      						})

			      						return {
				      						...character,
				      						text: character.name,
				      						hint: character.hasUnreadMessages ? `[M]` : '',
				      						className: isLobbyReady ? '' : 'disabled'
				      					}
			      					}),
			      					...otherOptions
			      				]
			      			}/>
      					)
	      			}
	      			<p className="footer">Copyright (<span className="action">c</span>) 2026 Harry Bishop</p>
	      		</div>
      		</div>
	    );
	}
}

const mapStateToProps = state => {
    const isInitialisingApp = selectIsInitialisingApp(state);
    const isInitialisingPanel = selectIsInitialisingPanel(state);

    const isInitialising = isInitialisingApp || isInitialisingPanel

    const user = selectUser(state);
    const characters = selectPossibleCharacters(state);
    const characterPanels = selectCharacterPanels(state);
    const rooms = selectRooms(state)

    return { isInitialising, characters, user, characterPanels, rooms }
}

export default connect(
    mapStateToProps,
    {
    	logOutAsync,
    	startNewGame,
    	getCharacterAsync,
    	initialisingPanelStarted,
    	newCharacterAsync,
    	changeCharacter,
    	hideAllMenus,
    	getUserBedsAsync,
    	getCharacterPanelsAsync
    }
)(Startup);